import { REPORT_SENSOR_REGISTRY } from "constant/report";
import { NullableNumber, ReportItemSummaryType } from "types/Reports";

import { getNumberOfItemsText } from "./utils/reportString";
import { formatValueAndUnitBasedOnTypeInReport } from "./utils/reportFormat";

type ReportTotalTextProps = {
    isValid: boolean;
    itemType: ReportItemSummaryType;

    textHighlightClassName: string;

    total: NullableNumber;
    numberOfItems: NullableNumber;
};

export default function ReportTotalText({
    isValid,
    itemType,
    textHighlightClassName,
    total,
    numberOfItems,
}: Readonly<ReportTotalTextProps>) {
    const totalDescriptionText = REPORT_SENSOR_REGISTRY[itemType].tabTotal;
    const numItemText = getNumberOfItemsText(numberOfItems, itemType);
    let unit = '';

    switch(itemType) {
        case 'room':
            break;
        case 'energy':
            unit = REPORT_SENSOR_REGISTRY.energy.unit;
            break;
        case 'water':
            unit = REPORT_SENSOR_REGISTRY.water.unit;
            break;
        case 'waterLeakage':
            break;
        default:
            break;
    }

    const localTotal = isValid ? total : null;
    const totalCurrentDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, localTotal, unit, false);

    return (
        <>
            <p className="report-total-text-desc">{`${totalDescriptionText}${numItemText}`}</p>
            <p className={`report-total-text ${textHighlightClassName}`}>
                {`${totalCurrentDisplay}`}
            </p>
        </>
    );
}
